<template>
  <div class="search-banner">
    <div class="banner-content">
      <p class="banner-headline">
        {{ $t('AIR.BANNER_HEADLINE') }}
      </p>
      <h2 class="banner-title">
        {{ $t('AIR.BANNER_TITLE') }}
      </h2>
      <div class="banner-search">
        <form class="search-input" @submit.prevent="submit">
          <i class="material-icons">
            search
          </i>
          <input v-model="keyword" :placeholder="$t('SEARCH.PLACEHOLDER')" type="text" aria-label="AIR search banner input">
        </form>
        <a class="search-btn" @click="submit">
          {{ $t('COMMON.SEARCH') }}
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AIRSearchBanner',
  components: {},
  directives: {},
  props: {},
  data() {
    return {
      keyword: ''
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    submit() {
      if (this.keyword) {
        this.$router.push({ name: 'search', query: { q: this.keyword, type: 'all' } })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.search-banner {
  position: relative;
  width: 100%;
  height: 100vh;
  min-height: 500px;
  margin: 0;
  margin-top: 24px;
  padding-bottom: 40vh;
  background-image: url('/img/banner/img-banner-css.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
  }
  &:after{
    content: "";
    position: relative;
    display: inline-block;
    width: 0px;
    height: 100%;
    vertical-align: middle;
  }
  .banner-content{
    display: inline-block;
    position: relative;
    top: 0;
    bottom: 0;
    margin-left: 14.5%;
    vertical-align: middle;
  }
  .banner-headline {
    font-size: 36px;
    font-weight: 500;
    line-height: normal;
    color: #505050;
    margin: 0 0 4px;
  }
  .banner-title{
    font-size: 20px;
    font-weight: 500;
    color: #505050;
    line-height: 1.6;
    margin: 0 0 24px;
  }
  .banner-search {
    position: relative;
    width: 593px;
    // margin: 0 auto;
    overflow: hidden;
    .search-input {
      display: inline-block;
      position: relative;
      float: left;
      width: calc(100% - 166px);
      padding: 0 24px;
      height: 56px;
      background: #ffffff;
      border-radius: 28px 0 0 28px;
      text-decoration: none;
      overflow: hidden;
      i {
        position: absolute;
        width: 24px;
        height: 24px;
        top: 0;
        bottom: 0;
        left: 24px;
        margin: auto;
        font-size: 24px;
        color: $theme-red;
      }
      input {
        width: 100%;
        height: 100%;
        outline: none;
        border: 0;
        padding-left: 32px;
        font-size: 16px;
        color: $grey-9b;
        line-height: 1.6;
        caret-color: $theme-yellow;
        background: #fff;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &::placeholder {
          color: $grey-9b;
          font-weight: bold;
        }
        &::selection {
          background-color: rgba(244, 185, 59, 0.28);
        }
      }
    }
    .search-btn {
      display: inline-block;
      position: relative;
      float: left;
      text-decoration: none;
      width: 166px;
      font-size: 24px;
      font-weight: 500;
      line-height: 56px;
      text-align: center;
      color: #ffffff;
      background: $theme-red;
      border-radius: 0 28px 28px 0;
      overflow: hidden;
      cursor: pointer;
    }
  }
}
@media only screen and (min-width: 1440px) {
}
@media only screen and (max-width: 1439.98px) {
  .search-banner {
    padding-bottom: 30vh;
    .banner-search {
      position: relative;
      width: 610px;
    }
    .banner-content{
      margin-left: 48px;
    }
  }
}
@media only screen and (max-width: 1023.98px) {
  .search-banner {
    .banner-search {
      position: relative;
      width: 571px;
    }
  }
}
@media only screen and (max-width: 767.98px) {
  .search-banner {
    // height: 232px;
    text-align: center;
    padding-bottom: 25vh;
    .banner-search {
      position: relative;
      width: 100%;
      // padding: 0 24px;
    }
    .banner-content{
      margin: 0 auto;
      padding: 0 16px;
      text-align: center;
    }
    .banner-headline {
      margin: 0 0 8px;
      // font-size: 20px;
      // font-weight: 500;
      // line-height: 1.6;
      // letter-spacing: normal;
      // color: #ffffff;
    }
    .banner-title{
      font-size: 16px;
      margin: 0 auto 16px;
      color: $grey-7d;
      width: 200px;
    }
    .banner-search {
      .search-input {
        width: 100%;
        border-radius: 4px;
        border: solid 1px $grey-ec;
        margin-bottom: 16px;
      }
      .search-btn {
        width: 100%;
        border-radius: 28px;
      }
    }
  }
}
</style>
